<template>
    <div class="n2-center-container" style="background-color:#fff; padding:10px;">
        <!--<div v-if="app_locale=='en'">
            <term-reservation-en></term-reservation-en>
        </div>
        <div v-else>
            <term-reservation-no></term-reservation-no>
        </div>-->
        <app-content name="web.term.reservation"></app-content>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    //import TermReservationEn from '../components/app/text/term-reservation.en.vue'
    //import TermReservationNo from '../components/app/text/term-reservation.no.vue'
    import AppContent from '../components/shared/content.vue';

    export default {
        components: {
            AppContent
            //TermReservationEn,
            //TermReservationNo
        },
        computed: {
            ...mapGetters('globalization', [
                'app_locale',
                'locale',
            ])
        }
    }
</script>
